import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
	name: 'safeHtml'
})

export class SafePipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) { }

  transform(style) {
    const html = this.decodeHtml(style);
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  decodeHtml(html: string): string {
  const txt = document.createElement('textarea');
  txt.innerHTML = html;
  return txt.value;
}
}
